export interface CustomDaysOfWeekT {
    customDaysOfWeek: string[] | undefined;
}

export const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function getDaysOfWeek(weekStartsOn: number | undefined, customDaysOfWeek: CustomDaysOfWeekT["customDaysOfWeek"]) {
    const allDaysOfWeek = customDaysOfWeek ?? weekDays;
    const daysOfWeek = [
      ...allDaysOfWeek.slice(weekStartsOn),
      ...allDaysOfWeek.slice(0, weekStartsOn),
    ];

    return daysOfWeek
    
}

export default getDaysOfWeek;
